/**
 * Mensagem de escassez: pedimos sempre autorização antes de alargar a
 * localidade. Funciona com ou sem cozinha explícita.
 */
export function cuisineScarceMessage(cuisine: string, area: string, lang: string): string {
  const c = cuisine?.trim() ? `${cuisine} ` : "";
  switch (lang) {
    case "pt":
      return `Não encontrámos restaurantes ${c}verificados em ${area}. Queres que alargue a pesquisa às localidades vizinhas?`;
    case "es":
      return `No encontramos restaurantes ${c}verificados en ${area}. ¿Quieres que amplíe la búsqueda a las localidades cercanas?`;
    case "fr":
      return `Aucun restaurant ${c}vérifié à ${area}. Veux-tu que j'élargisse la recherche aux localités voisines ?`;
    case "de":
      return `Keine geprüften ${c}Restaurants in ${area}. Soll ich die Suche auf die Nachbarorte ausweiten?`;
    case "ja":
      return `${area}で確認できる${cuisine ?? ""}レストランが見つかりませんでした。近隣まで検索を広げますか？`;
    default:
      return `We found no verified ${c}restaurants in ${area}. Want me to widen the search to nearby areas?`;
  }
}
